import LiveDrawPage from "./liveDraw.container";

export default LiveDrawPage;
